import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { of } from 'rxjs/observable/of';
import { AuthService } from '../../services';
import {
  types as actions,
  loggedInAction,
  readTokenErrorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.READ_TOKEN),
    switchMap(action => {
      if (AuthService.getToken()) {
        return of(loggedInAction());
      }
      return of(readTokenErrorAction({}));
    })
  );
}



// WEBPACK FOOTER //
// ./src/epics/auth/readToken.js